export default [{
        path: '/manageruser/releaseResources',
        name: 'releaseresources',
        component: resolve => require(['@/components/manageruser/releaseResources.vue'], resolve),
        meta: {
            title: '发布资源',
            requiresAuth: true // 添加表示需要验证是否登录
        }
    }, {
        path: '/manageruser/information',
        name: 'managerinformation',
        component: resolve => require(['@/components/manageruser/information.vue'], resolve),
        meta: {
            title: '基本信息',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/company',
        name: 'managercompany',
        component: resolve => require(['@/components/manageruser/company.vue'], resolve),
        meta: {
            title: '企业简介',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/contactUs',
        name: 'managercontactus',
        component: resolve => require(['@/components/manageruser/contactUs.vue'], resolve),
        meta: {
            title: '联系方式',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/systemSetup',
        name: 'managersystemsetup',
        component: resolve => require(['@/components/manageruser/systemSetup.vue'], resolve),
        meta: {
            title: '系统设置',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/sourcesPublished',
        name: 'sourcespublished',
        component: resolve => require(['@/components/manageruser/sourcesPublished.vue'], resolve),
        meta: {
            title: '发布货源',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/warehousePublished',
        name: 'warehousepublished',
        component: resolve => require(['@/components/manageruser/warehousePublished.vue'], resolve),
        meta: {
            title: '发布仓储资源',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/parkPublished',
        name: 'parkpublished',
        component: resolve => require(['@/components/manageruser/parkPublished.vue'], resolve),
        meta: {
            title: '发布园区资源',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/linePublished',
        name: 'linepublished',
        component: resolve => require(['@/components/manageruser/linePublished.vue'], resolve),
        meta: {
            title: '发布专线资源',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/contactUsPublished',
        name: 'contactuspublished',
        component: resolve => require(['@/components/manageruser/contactUsPublished.vue'], resolve),
        meta: {
            title: '发布联系方式',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/supplyList',
        name: 'supplylist',
        component: resolve => require(['@/components/manageruser/supplyList.vue'], resolve),
        meta: {
            title: '货源管理',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/parkList',
        name: 'parklist',
        component: resolve => require(['@/components/manageruser/parkList.vue'], resolve),
        meta: {
            title: '园区资源管理',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/warehouseList',
        name: 'warehouselist',
        component: resolve => require(['@/components/manageruser/warehouseList.vue'], resolve),
        meta: {
            title: '仓储资源管理',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/lineList',
        name: 'linelist',
        component: resolve => require(['@/components/manageruser/lineList.vue'], resolve),
        meta: {
            title: '专线资源管理',
            requiresAuth: true
        }
    },
    {
        path: '/manageruser/submission',
        name: 'submission',
        component: resolve => require(['@/components/manageruser/submission.vue'], resolve),
        meta: {
            title: '递交需求',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/jobsPublished',
        name: 'jobspublished',
        component: resolve => require(['@/components/manageruser/jobsPublished.vue'], resolve),
        meta: {
            title: '发布招聘信息',
            requiresAuth: true
        }
    }, {
        path: '/manageruser/jobsList',
        name: 'jobslist',
        component: resolve => require(['@/components/manageruser/jobsList.vue'], resolve),
        meta: {
            title: '招聘信息管理',
            requiresAuth: true
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/managerUserRouter.js